import * as React from "react";
import { Input } from "./input";

const group = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
const display = (v) => {
  const s = String(v ?? "");
  if (!s) return "";
  const [i, d] = s.split(".");
  return d !== undefined ? `${group(i)},${d}` : group(i);
};

export const QtyInput = React.forwardRef(({ value, onChange, decimal = false, className = "", ...props }, ref) => (
  <Input
    ref={ref}
    type="text"
    inputMode={decimal ? "decimal" : "numeric"}
    autoComplete="off"
    className={`font-mono ${className}`}
    value={display(value)}
    onChange={(e) => {
      let raw = e.target.value.replace(/\./g, "").replace(",", ".");
      raw = decimal ? raw.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1") : raw.replace(/\D/g, "");
      onChange(raw);
    }}
    {...props}
  />
));
QtyInput.displayName = "QtyInput";
